import { createElement } from 'react';

interface WeaveButtonProps extends React.HTMLAttributes<HTMLElement> {
	disabled?: boolean;
	type?: 'button' | 'submit' | 'reset';
	variant?: 'solid' | 'flat' | 'outlined' | 'white' | 'white-outlined';
	iconposition?: 'left' | 'right';
	density?: 'high' | 'medium';
}

export function WeaveButton({
	className,
	disabled,
	type,
	variant,
	iconposition,
	density = 'high',
	...rest
}: WeaveButtonProps) {
	return createElement('weave-button', {
		className,
		disabled,
		type,
		variant,
		iconposition,
		density,
		...rest,
	});
}
